export default __webpack_public_path__ + "static/media/sponsor-3.5867b0f6.png";